var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`railway-control__list-item-status ${_vm.getColorType()}`]},[_c('r-text',{attrs:{"type":"caption","color-type":_vm.getColorType()}},[_vm._v(" "+_vm._s(_vm.$t(_vm.getCarStatusName()))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }